module.exports = __webpack_public_path__ + "static/media/rackEmpty.9cc57645.svg";